import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const patreon = defineConnector({
  identifier: "patreon",
  name: "Patreon",
  tagLine: "Membership platform for creators",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://www\\.patreon\\.com/api/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Get your Patreon access token",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [Patreon Developer Portal](https://www.patreon.com/portal/registration/register-clients), create or select a client, and copy the **Creator's Access Token**.",
        },
        {
          kind: "input",
          label: "Access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://www.patreon.com/api/oauth2/v2/identity",
  },
});
